/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/reducers/admin";
import { actions as stkActions } from '../../../../store/reducers/stakeholder';
import { actions as sclActions } from '../../../../store/reducers/scl';
import { actions as lirActions } from '../../../../store/reducers/lir';
import { actions as admActions } from '../../../../store/reducers/adm';
import { Typography, message, Modal } from 'antd';
import { Style } from './style';
import Footer from './footer';
import { isEmptyOrSpaces } from '../../../../helpers/StringHelper';
import Loading from '../../../../components/Loading';
import Confirmation from './components/confirmation';
import { getValue } from '../helper';
import { ExclamationCircleOutlined } from '@ant-design/icons';

function Merger({
  fetchData = () => { },
  itemsToMerge = [],
  setItemsToMerge = () => { },
  stakeholder: { data: stakeholderData },
  scl: { data: locationsData, retrived },
  lir: { data: lirData, retrived: lirRetrived },
  adm: { data: admData, retrived: admRetrived },
  stakeholderDataGet,
  SCLDataGet,
  lirDataGet,
  admDataGet,
  mergerColumns = [],
  view,
  admLevels = {},
  entity,
  mergeGlobal,
  checkMergeGlobal,
  module,
  close,
  clearItemsToMerge,
  loading = false,
  setLoading = () => { },
  t = (s) => s,
}) {
  const [form, setForm] = useState(null);
  const [data, setData] = useState({});
  const [extraAdded, setExtraAdded] = useState([]);
  const [requiredFields, setRequiredFields] = useState([]);
  const [areYouSureState, setAreYouSureState] = useState(false);

  const columns = mergerColumns;

  const formFn = {
    stakeholders: stakeholderDataGet,
    locations: SCLDataGet,
    scl: SCLDataGet,
    scp: stakeholderDataGet,
    lir: lirDataGet,
    administrativeLevel1: admDataGet,
    administrativeLevel2: admDataGet,
    administrativeLevel3: admDataGet,
    administrativeLevel4: admDataGet,
    administrativeLevel5: admDataGet,
    administrativeLevel6: admDataGet,
    administrativeLevel7: admDataGet,
    administrativeLevel8: admDataGet,
    administrativeLevel9: admDataGet,
    administrativeLevel10: admDataGet,
  };

  const namespace = {
    stakeholders: 'Stakeholder',
    locations: 'SCL',
    scl: 'SCL',
    scp: 'Stakeholder',
    lir: 'Lir',
    administrativeLevel1: 'ADM',
    administrativeLevel2: 'ADM',
    administrativeLevel3: 'ADM',
    administrativeLevel4: 'ADM',
    administrativeLevel5: 'ADM',
    administrativeLevel6: 'ADM',
    administrativeLevel7: 'ADM',
    administrativeLevel8: 'ADM',
    administrativeLevel9: 'ADM',
    administrativeLevel10: 'ADM',
  };

  useEffect(() => {
    formFn[entity]({ namespace: namespace[entity], module, view: admLevels[entity] || view });
  }, [entity]);

  useEffect(() => {
    if (stakeholderData[`${module}-${view}`]) {
      setForm(stakeholderData[`${module}-${view}`].form || {});
    }
  }, [stakeholderData]);

  useEffect(() => {
    if (locationsData[`${module}-${view}`]) {
      setForm(locationsData[`${module}-${view}`].form || {});
    }
  }, [locationsData, retrived]);

  useEffect(() => {
    if (lirData[`${module}-${view}`]) {
      setForm(lirData[`${module}-${view}`].form || {});
    }
  }, [lirData, lirRetrived]);

  useEffect(() => {
    if (admData[`${admLevels[entity] || view}`]) {
      const admForm = admData[`${admLevels[entity] || view}`].form || {};
      admForm.location = Object.keys(admForm.location).reduce((item, key) => {
        item[key] = admForm.location[key];
        return item;
      }, {});
      setForm(admData[`${admLevels[entity] || view}`].form || {});
    }
  }, [admData, admRetrived, admLevels[entity]]);

  const formValue = useMemo(() => {
    if (form) {
      return Object.values(form)[0];
    }
    return null;
  }, [form]);

  const mappedColumns = useMemo(() => {
    const mC = [];
    if (formValue && columns) {
      columns.forEach((c) => {
        if (c.tableOnly) {
          return;
        }

        if (formValue[c.dataIndex]) {
          mC.push({
            ...formValue[c.dataIndex],
            noMerge: c.noMerge,
            title: c.title,
            dataIndex: c.dataIndex,
          });
        } else if (c.dataIndex !== 'action') {
          mC.push({
            inputType: 'text',
            noMerge: c.noMerge,
            title: c.title,
            dataIndex: c.dataIndex,
          });
        }
      });
    }
    return mC;
  }, [formValue, columns]);


  const mappedData = useMemo(() => {
    const mD = [];
    if (mappedColumns.length) {
      itemsToMerge.forEach((c, i) => {
        const row = [];
        mappedColumns.forEach((m) => {
          if (c[m.dataIndex]) {
            row.push(getValue(c[m.dataIndex], m));
          } else {
            row.push(null);
          }
        });
        mD.push(row);
      });
    }
    return mD;
  }, [mappedColumns, itemsToMerge]);

  const mappedInputs = useMemo(() => {
    const inputs = {};
    if (columns && columns.length && formValue) {
      columns.forEach((c) => {
        if (c.tableOnly) {
          return;
        }

        if (formValue[c.key]) {
          if (!c.noMerge) {
            inputs[c.key] = {
              ...formValue[c.key],
              columnConfig: c,
            };
          } else {
            inputs[c.key] = {
              inputType: '',
              columnConfig: c,
            };
          }
        } else if (c.key === 'province') {
          inputs.administrativeLevel1 = formValue.administrativeLevel1;
        } else if (c.key === 'territory') {
          inputs.administrativeLevel2 = formValue.administrativeLevel2;
        } else if (c.key === 'datastakeId') {
          inputs[c.key] = {
            inputType: 'select',
            columnConfig: c,
            options: itemsToMerge.map(i => ({ value: i.datastakeId, label: i.datastakeId })),
          };
        } else if (c.key !== 'action') {
          inputs[c.key] = {
            inputType: 'text',
            columnConfig: c,
          };
        }
      });
    }
    return inputs;
  }, [formValue, columns, itemsToMerge]);

  useEffect(() => {
    const first = itemsToMerge[0];
    if (first && extraAdded.length === 0) {
      setData({ datastakeId: first.datastakeId });
    }
  }, [itemsToMerge]);

  const mergeIsDisabled = useMemo(() => {
    const nFF = [];

    requiredFields.forEach((f) => {
      if (!data[f]) {
        nFF.push(f);
      } else if (isEmptyOrSpaces(data[f])) {
        nFF.push(f);
      }
    });

    if (nFF.length === 0) {
      return false;
    } else {
      return true;
    }
  }, [requiredFields, data]);

  const firstItem = useMemo(() =>
    itemsToMerge[0] ? itemsToMerge[0] : null, [itemsToMerge]);

  const onSubmit = useCallback(() => {
    setLoading(true);
    const ids = itemsToMerge.map((i) => i.datastakeId);

    mergeGlobal(
      entity,
      { data, ids },
      () => {
        setLoading(false);
        close();
        clearItemsToMerge();
        fetchData();
      },
      (err) => {
        setLoading(false);
        message.error(err.data && err.data.message ? err.data.message : (err.message || 'Something went wrong through merge'))
      }
    );
  }, [data, itemsToMerge]);

  const confirm = (subjects) => {
    Modal.confirm({
      title: 'Confirm',
      icon: <ExclamationCircleOutlined />,
      content: 'More subjects were found with similar core data. They will also be merged if you continue this operation',
      okText: 'Continue',
      cancelText: 'Cancel',
      onOk: () => {
        setItemsToMerge(subjects)
      }
    });
  }

  const onCheck = useCallback(() => {
    setLoading(true);
    const ids = itemsToMerge.map((i) => i.datastakeId);

    checkMergeGlobal(
      entity,
      { data, ids },
      (checkData) => {
        setLoading(false);
        if (Array.isArray(checkData) && checkData.length) {
          setExtraAdded([...checkData.map(d => d.datastakeId)])
          confirm([...itemsToMerge, ...checkData])
        } else {
          setExtraAdded([])
          setAreYouSureState(true);
        }
      },
      (err) => {
        setExtraAdded([])
        setLoading(false);
        message.error(err.data && err.data.message ? err.data.message : (err.message || 'Something went wrong through check merge'))
      }
    );
  }, [data, itemsToMerge]);

  const renderedColumnsHeader = useMemo(() => mappedColumns.map((col, i) => (
    <div className="item" key={`${col.title}-${i}`}>
      <Typography.Text>
        {col.title}
      </Typography.Text>
    </div>
  )), [mappedColumns]);

  const renderedRows = useMemo(() => mappedData.map((col, i) => (
    <div className={`row ${extraAdded.includes(col[0]) ? 'extra-added' : ''}`} key={`data-${i}`}>
      {col.map((c, j) => (
        <div className="item" key={`${c}-${i}-${j}`}>
          <Typography.Text>
            {c}
          </Typography.Text>
        </div>
      ))}
    </div>
  )), [mappedData]);

  return (
    <Style>
      {loading && <Loading />}
      <div className='table-body'>
        <div className="header row">
          {renderedColumnsHeader}
        </div>
        {renderedRows}
      </div>
      <Footer
        areYouSureState={areYouSureState}
        inputs={mappedInputs}
        firstItem={firstItem}
        data={data}
        setData={setData}
        requiredFields={requiredFields}
        setRequiredFields={setRequiredFields}
        t={t}
      />
      <Confirmation
        t={t}
        mergeIsDisabled={mergeIsDisabled}
        close={close}
        setAreYouSureState={setAreYouSureState}
        areYouSureState={areYouSureState}
        onSubmit={onSubmit}
        onCheck={onCheck}
      />
    </Style>
  );
}

const mstp = ({ admin, stakeholder, scl, lir, adm }) => ({ admin, stakeholder, scl, lir, adm });

export default connect(mstp, { ...actions, ...stkActions, ...sclActions, ...lirActions, ...admActions })(Merger);